import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { AtlassianEmailUserIdMapping } from '@atlassian/cssxp-types-atlasaccnt';

const client = createAxiosClient({ baseURL: '/api/1' }, ServiceProxyMap.AUTH);

export const fetchAtlassianAccountIDByEmail = async (requestPayload: {
  emails: Array<string>;
}): Promise<Array<AtlassianEmailUserIdMapping>> => {
  const AtlassianAccountIDResponse = await client.post('/users/fetch/by-email', requestPayload);
  return AtlassianAccountIDResponse.data;
};

export const createAtlassianAccountWithNameAndEmail = async (
  email: string,
  displayName: string,
  application: string
): Promise<{ id: string }> => {
  const AtlassianAccountResponse = await client.post('/users/signup', { email, displayName, application });
  return AtlassianAccountResponse.data;
};

export const fetchAccountDetailsByIds = async (atlassianAccountIds: string[]) => {
  const response = await client.post('/users/fetch/by-accountIds', { atlassianAccountIds });
  return response.data;
};
